import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Result, Spin } from "antd";
import type { Permission } from "@salon/shared";
import { useAuth } from "../../stores/auth";
import { api } from "../../lib/api";

export default function RequireAuth({
  children,
  permission,
}: {
  children: React.ReactNode;
  permission?: Permission;
}) {
  const { user, accessToken, setAuth, clear, hasPermission } = useAuth();
  const location = useLocation();
  const [checking, setChecking] = useState(!user);

  useEffect(() => {
    // Không có token → coi như chưa login, redirect /login.
    if (!accessToken) {
      setChecking(false);
      return;
    }
    let alive = true;
    api.api.auth.me
      .$get()
      .then(async (r) => {
        if (!alive) return;
        if (r.ok) {
          const data = (await r.json()) as {
            user: any;
            permissions: Permission[] | null;
          };
          setAuth(data.user, data.permissions);
        } else {
          clear();
        }
      })
      .catch(() => {
        clear();
      })
      .finally(() => alive && setChecking(false));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checking) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (permission && !hasPermission(permission)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Bạn không có quyền truy cập trang này"
      />
    );
  }
  return <>{children}</>;
}
